import Input2 from '../../../components/input2';
import SubmitBtn2 from '../../../components/submit2';
import sty from './s.module.scss';
import Header2 from '../../../components/header2';

import Notif from '../../../components/notif';
import { useState,useEffect } from 'react';
import { Outlet, Link, useLoaderData,useActionData, Form } from 'react-router-dom';

import { loaderPostFetch } from '../util';

import PinInput from "react-pin-input";

import {wpUser,production} from '../../../../k';
/*
import s from './style.module.scss';

import Card, { Card2 } from '../../../components/card';
import Input1 from '../../../components/input';
import Notif from '../../../components/notif';

import {wpUser,production} from '../../../../k';

import CopyInput from '../../../components/copyinput';
import { Outlet, Link, useLoaderData, Form } from 'react-router-dom';

import { useRef, useState, useEffect } from 'react';
import SubmitBtn from '../../../components/submit';
import { loaderPostFetch,gfUrl } from '../util';

import { useActionData, useSubmit } from 'react-router-dom';

export async function paction({ request, params }) {
  //loader will fetch details
  const formData = await request.formData();

  let tok = window.localStorage.getItem('baUid');
  if (tok != null) {
    formData.append('token', tok);
  }
  const contact = await loaderPostFetch(`api/users.php`, formData);

  return contact;
}
*/

export async function resetaction({ request, params }) {
  //loader will fetch details
  const formData = await request.formData();
  formData.append("action","reset");
  const updates = Object.fromEntries(formData);
  updates['action'] = 'reset';
  //let contact;
  //const contact = await
  const contact = await loaderPostFetch(`api/users.php?crud=userforgotpin`, formData);/*
    .then((s) => {
      if (s?.error) {
        //s?.message
      } else {
      }
    })
    .catch((e) => {
      console.log(e);
    });*/

  return contact;
}
export async function resetloader({ params }) {
  console.log({ params });

  const sessions = {}; //new Promise();// await getfetch(`${apiUrl}/sessionlist`, {});
  return { sessions, ...params };
}

export default function Reset() {
  const [n, sN] = useState({ display: false, type: 'success', msg: '' });

  //requires params email/:token
  //const email = '';
  let actionData = useActionData();
  const { email,token } = useLoaderData();


  useEffect(() => {
    /*console.log({ actionData });*/
    if (actionData) {
      let s = actionData;
      if (s?.icon == 'success') {
        //window.localStorage.setItem('baUid', s?.jwt);
       // window.localStorage.removeItem('tempbaUid');
       if (typeof s?.message=='undefined') {}else{
       sN({ display: true, type: 'success', msg: `${s?.message}` });
        setTimeout(() => {
          sN({ display: false, type: 'error', msg: `` });
          window.location.href = `${wpUser}/account/login`;
        }, 5000);
       }
        
      }else if (s?.icon=="error") {

       if (typeof s?.message=='undefined') {}else{
        sN({ display: true, type: 'error', msg: `${s?.message}` });
        setTimeout(() => {
          sN({ display: false, type: 'error', msg: `` });
        }, 5000);
       }
      } 
    }
  }, [actionData]);


  const [pat2, setPat2] = useState(`.{6,6}|[0-9]*`);

  function escapeRegExp(str) {
      return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    }
    function handleChange(e) {
        //setValue(e.target.value);
        if(!e.target.value) return;

  // if non numeric
  let isNum = e.target.value[e.target.value.length - 1].match(/[0-9]/g);
  if(!isNum) e.target.value = e.target.value.substring(0, e.target.value.length - 1);


  setPat2(escapeRegExp(e.target.value));

  }

  //
  return (
    <div>
      <Notif display={n?.display} type={n?.type} msg={n?.msg} />
      <Header2 href={`${window['login']}`} title="Sign In" />

      <div className={sty.sub}>
        <div className={sty.text}>Create New Transfer PIN</div>

        <div className={sty.lock}></div>
      </div>

      <div className={sty.s}>This Transfer PIN should be different from your previous PIN</div>

      <Form method="post">
      {/*<Input2 name="reset_code" type="password" placeholder="Reset Code" hasIcon="show" toggleIconWith="hide" />
        */}
        <input type="hidden" name="reset_code" value={token} />
        <input type="hidden" name="email" value={email} />
        
        <Input2 name="new_password" maxlength={4} pattern=".{4,4}|[0-9]*" oninput={handleChange} required={true} 
        title="Transfer PIN must be 4 digits" type="password" placeholder="Create PIN (4 digits)" hasIcon="show" toggleIconWith="hide" />
        
        <Input2 type="password" maxlength={4} pattern={pat2} placeholder="Confirm PIN" hasIcon="show" toggleIconWith="hide" />

         {/*<div className={sty.remeber}>
          <div className={sty.l}>
            <input type="checkbox" />
            <div className={sty.text}>I&apos;m at least 18 years old and agree to the following terms:</div>
          </div>
        </div>
         <div className={sty.r}>
    <a href="">Forgot Passcode?</a>
    </div>*/}

        {/*<div className={sty.note}>
          By tapping Next. I've read and agree to the
          <a className={sty.imp} href="/b/sign.pdf">
            E-Sign Disclosure and Consent
          </a>{' '}
          to receive all communications electronically
        </div>*/}

        <SubmitBtn2 label="Continue" />
      </Form>
    </div>
  );
}
